<script>
    import http from "../http";
    import FButtonSection from "@/components/FButtonSection";

    export default {
        name: "FPageHome",
        components: { FButtonSection }
    };
</script>

<template>
    <section>
        <FButtonSection
            to='/administracao'
            icon='how_to_reg'
            title='Administração'
            descr='Informações sobre sua empresa'
        />
        <FButtonSection
            to='/vendas'
            icon='shopping_cart'
            title='Vendas'
            descr='Vendas de Produtos e Combustíveis'
        />
        <FButtonSection
            to='/estoque'
            icon='assignment'
            title='Estoque'
            descr='Controle de Estoque'
        />
        <FButtonSection
            to='/financas'
            icon='attach_money'
            title='Finanças'
            descr='Controle do cartão TEF'
        />
    </section>
</template>